<template>
  <div class="title-bar"> 
    <div class="meta-chip-container">
      <v-icon color="red" small style="float: left;">mdi-close-circle</v-icon>
      <div style="text-align: center; color: #aaa; font-style: italic; font-size: .9rem;">MogwaiFulton - 6 Days Ago</div>
      <!-- <username-chip :mini="this.mini" class="meta-chip" />
      <time-chip class="meta-chip" :mini="this.mini"/>
      <div class="vote-container">
        <upvote-chip class="meta-chip" />
        <downvote-chip class="meta-chip" style="margin-right: 0px;"/> -->
      <!-- </div> -->
    </div>

    <!-- <span class="post-title">
      Brush Time
    </span> -->
  </div>
</template>

<script>
// import UsernameChip from "./username-chip.vue";
// import TimeChip from "./time-chip.vue";
// import DownvoteChip from "./downvote-chip.vue";
// import UpvoteChip from "./upvote-chip.vue";

export default {
  name: "TitleBar",
  components: {
    // UsernameChip,
    // TimeChip,
    // DownvoteChip,
    // UpvoteChip,
  },
  methods: {},
  props: {
    mini: {type: Boolean, default: false}
  },
  data: () => ({}),
};
</script>


<style scoped>
.title-bar {
}
.close {
  padding: 0;
  margin-left: -10px;
  margin-top: -10px;
}
.meta-chip {
  margin-right: 5px;
  float: left;
}
.vote-container {
  float: right;
}
.post-title {
  width: 100%;
  font-size: 1.2rem;
  float: left;
  background-color: #222;
  padding: 5px 13px;
}
.meta-chip-container {
  width: 100%;
  display: table;
  background-color: #1a1a1a;
  border-radius: 5px;
  padding: 5px 5px;
}
</style>